import { useGet, usePut } from "@/api/lib/integration";
import type { ConfirmData, NotificationSettings } from "@/api/account/types";

export const confirmEditEmail = useGet<ConfirmData, string>('/api/account/confirm-edit-email');
export const confirmEmailChange = useGet<ConfirmData, string>('/api/account/confirm-email-change');
export const confirmPasswordChange = useGet<ConfirmData, string>('/api/account/confirm-password-change');
export const getNotificationSettings = useGet<void, NotificationSettings>('/api/account/notification-settings');
export const putNotificationSettings = usePut<NotificationSettings, void>('/api/account/notification-settings');
